module.exports = __webpack_public_path__ + "img/eq-trang-oulsclaws.167c8eb3.png";